//Core modules
import React from 'react';

//External modules
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";

//Internal modules
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyApiKey extends React.Component {

    render() {
        return (
            <>
            <div>
                <div className='ml-2 mb-2' style={{ /*position: 'relative'*/ }}>
                    <span className={'cursor-pointer'} style={{ position: 'absolute' }} onClick={(e) => {this.props.onBackAction(e)}}>
                        <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                    </span>
                    <span className='api-doc'> 
                        <a target='_blank' href={`https://api.cratiocrm.com/#/`} className={`header-notification-url  analyticsbussinessbtn le-button lePrimaryBtn le-api-btn btn btn-success me-2 w-2`}>{`API Documentation`}</a>
                    </span>
                </div>
            </div>
                
                
                
                <LegacyFrame withHeader={false} pageTitle={"API Key"} formname={"table_32"} customClass={"field-customization-container"} />
            </>
        );
    }
}

export default LegacyApiKey;
